export default __webpack_public_path__ + "static/sms-message-icon-b5306522fc1ebd65777078d625f55df8.png";